import { render, staticRenderFns } from "./RankingLojas.vue?vue&type=template&id=141a9101&scoped=true&"
import script from "./RankingLojas.vue?vue&type=script&lang=js&"
export * from "./RankingLojas.vue?vue&type=script&lang=js&"
import style0 from "./RankingLojas.vue?vue&type=style&index=0&id=141a9101&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a9101",
  null
  
)

export default component.exports